/**
 * The complaint pill under a customer's name on the Customers table
 * (kanban 2a28d4c0): "⚑ 2 open complaints · INV-…" with who it waits on, or
 * "✓ complaint INV-… completed <date>". Renders nothing without a summary.
 */
import type { CustomerQualitySummary } from '../../../services/portalQualityAsks';
import { completedPillLabel, openPillDetail, openPillLabel } from './complaintView';
import styles from './Complaints.module.css';

export default function ComplaintPill({ summary }: { summary: CustomerQualitySummary | undefined }) {
  if (!summary) return null;
  const open = openPillLabel(summary);
  if (open) {
    const detail = openPillDetail(summary);
    return (
      <div className={styles.pillRow} data-testid="complaint-pill">
        <span className={`${styles.pill} ${styles.pillOpen}`}>{open}</span>
        {detail && <span className={styles.pillDetail}>{detail}</span>}
      </div>
    );
  }
  const done = completedPillLabel(summary);
  if (!done) return null;
  return (
    <div className={styles.pillRow} data-testid="complaint-pill">
      <span className={`${styles.pill} ${styles.pillDone}`}>{done}</span>
    </div>
  );
}
